import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '@app/lib/b2b-services/auth/auth.service';
import { LoggerService } from '@app/lib/b2b-services/util/logger.service';
import { RouterUtilService } from '@app/lib/b2b-services/util/router-util.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(
    private authService: AuthService,
    private routerUtilService: RouterUtilService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authService.getAuthToken().pipe(
      map((token: string) => {
        /*LoggerService.log('Inside AuthGuard ', token);*/
        if (token) {
          return true;
        }

        // Validating the state url if correct url then only adding it to redirect_to
        // otherwise simply keeping login page url with no redirect_to
        const targetUrl: string = state?.url || '/';
        const isConcreteAppRoute: boolean =
          targetUrl && targetUrl !== '/app' && targetUrl !== '/app/' && targetUrl?.startsWith('/app/');
        const loginUrl: string = isConcreteAppRoute
          ? `/auth/login?redirect_to=${encodeURIComponent(targetUrl)}`
          : '/auth/login';

        this.routerUtilService.navigateByUrl(loginUrl).then();
        return false;
      })
    );
  }
}
